import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { TemperatureDisplaySkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/TemperatureDisplaySkeleton';

export function TemperatureDisplay() {
    return (
        <SuspenseWrapper loadingComponent={<TemperatureDisplaySkeleton />}>
            <WrappedTemperatureDisplay />
        </SuspenseWrapper>
    );
}

function WrappedTemperatureDisplay() {
    const { device } = useContext(DeviceDetailContext);
    const { value, units, minRange, maxRange, minMeasured, maxMeasured, timestamp } =
        useSnapshot({
            snapshotType: 'Temperature',
            parentId: device.id,
            shelfLife: { hours: 1 },
        }) ?? {};
    const unitSymbol = units?.charAt(0) ?? '';

    return (
        <ContentBox.Section heading="Device Temperature" disableDivider timestamp={timestamp}>
            <SimpleGrid className="DeviceTemperatureStatusDisplay" columns={3}>
                <StatDisplay
                    name="Current temperature"
                    value={value}
                    unit={`°${unitSymbol}`}
                    decimalPlaces={1}
                />
                <StatDisplay
                    name="Min sensor value"
                    value={minRange}
                    unit={`°${unitSymbol}`}
                    decimalPlaces={1}
                />
                <StatDisplay
                    name="Max sensor value"
                    value={maxRange}
                    unit={`°${unitSymbol}`}
                    decimalPlaces={1}
                />
                <StatDisplay
                    name="Min temperature measured"
                    value={minMeasured}
                    unit={`°${unitSymbol}`}
                    decimalPlaces={1}
                />
                <StatDisplay
                    name="Max temperature measured"
                    value={maxMeasured}
                    unit={`°${unitSymbol}`}
                    decimalPlaces={1}
                />
            </SimpleGrid>
        </ContentBox.Section>
    );
}
